import * as _ from 'underscore';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GaEventService } from '@app/shared/services/ga-event.service';
import { EVENT_SAVE_FAQ } from '@app/shared/app-events';
import { IDialogButton } from '@app/shared/message/ga-message.service';

const SAVE_ACTION:string = 'saveFaq';

@Component({
  selector: 'faq-manage-dialog',
  template: `
    <default-dialog [title]="title" [buttons]="buttons" [closeButton]="true">
      <faq-manage [faqId]="faqId" [create]="!faqId" [showInDialog]="true" (onSaved)="onSaved.emit($event)" (onSaving)="onSaving($event)"></faq-manage>
    </default-dialog>
  `
})
export class FaqManageDialogComponent {
  @Input() public faqId:string;
  @Output() public onSaved = new EventEmitter<any>();

  public buttons:IDialogButton[];
  public title:string;

  constructor(
    private eventService:GaEventService
  ) {}

  public ngOnInit():void {
    this.title = this.faqId ? 'Edit FAQ' : 'Add FAQ';
    this.buttons = [ {
      id: SAVE_ACTION,
      label: 'Save FAQ',
      onClick: () => {
        this.eventService.sendMessage(EVENT_SAVE_FAQ);
      },
      className: 'btn btn-success'
    }, {
      label: 'GA.BUTTONS.CANCEL',
      className: 'btn btn-danger'
    } ];
  }

  public onSaving(busy:boolean):void {
    const saveButton:IDialogButton = _.findWhere(this.buttons, { id: SAVE_ACTION });
    saveButton.busy = busy;
  }
}